import type { PropsWithChildren } from 'react'
import { forwardRef } from 'react'

import type { UseBooleanFlagApi } from '../../../../hooks'
import type { OnEndCallback } from '../DialogModal'
import { DialogModal } from '../DialogModal'
import css from './DeleteModal.css'

type DeleteModal = {
  handleDelete: VoidFunction
  onEnd?: VoidFunction
}

export const DeleteModal = forwardRef<UseBooleanFlagApi, PropsWithChildren<DeleteModal>>(
  function DeleteModal({ onEnd, children, handleDelete }, ref) {
    const handleEnd: OnEndCallback = ({ performAction }) => {
      if (performAction) {
        handleDelete()
      }
      onEnd?.()
    }

    return (
      <DialogModal
        ref={ref}
        className={css.deleteModal}
        submitLabel="Удалить"
        cancelLabel="Отмена"
        initialValue={undefined}
        onEnd={handleEnd}>
        {() => children}
      </DialogModal>
    )
  },
)
